import { Button } from '@akin-home/buttons/native';
import React from 'react';

interface BluetoothScanButtonProps {
  isScanning: boolean;
  onStartScanning: () => void;
  onStopScanning: () => void;
}

export const BluetoothScanButton = (props: BluetoothScanButtonProps) => {
  const { isScanning, onStartScanning, onStopScanning, ...rest } = props;

  return (
    <Button
      size="large"
      icon={['far', isScanning ? 'sync' : 'bluetooth']}
      onPress={isScanning ? onStopScanning : onStartScanning}
      {...rest}
    >
      {isScanning ? 'Stop Scanning' : 'Start Scanning'}
    </Button>
  );
};
